import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import { logPurchase } from "../misc/firebase";
import type { ECommerceOfferProductWithNames, ECommerceOfferResponse } from "./eCommerceApi";
import { bookECommerceOffer } from "./eCommerceApi";

export const useBookOffer = (offer: Pick<ECommerceOfferResponse, "id" | "name">) => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const bookOfferMutation = useMutation<
    { orderId: string },
    unknown,
    { note: string; products: Pick<ECommerceOfferProductWithNames, "id" | "price" | "currency">[] }
  >({
    mutationFn: ({ note }) => bookECommerceOffer(offer.id.value, note),
    onSuccess: async (data, { products }) => {
      enqueueSnackbar(`"${offer.name}" została zarezerwowana`, { variant: "success" });
      await queryClient.invalidateQueries({ predicate: (q) => q.queryKey[0] === "e-commerce" });
      queryClient.removeQueries({ queryKey: ["orders", data.orderId] });
      logPurchase(
        data.orderId,
        products.map((p) => ({
          id: p.id,
          value: typeof p.price === "number" ? p.price : undefined,
          currency: p.currency,
        })),
      );
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się dokonać rezerwacji. Powód: ${(error as Error).message}`);
    },
  });

  return {
    book: (note: string, products: Pick<ECommerceOfferProductWithNames, "id" | "price" | "currency">[]) =>
      bookOfferMutation.mutateAsync({ note, products }),
  };
};
